export default __webpack_public_path__ + "static/media/chrome_future.3e8f0ea8.gif";